export default ['api', function (api) {
    return {
        orderHistory: (timeframe, page) => {
            return api.get(`history?timeframe=${timeframe}&page=${page}`)
                .then(response => response.data);
        },

        emailInvoice: (basketCode) => {
            return api.post(`email-invoice`, {
                basketCode: basketCode
            })
                .then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/services/user.service.js